import { render, staticRenderFns } from "./Logged.vue?vue&type=template&id=70378bc2&scoped=true&"
import script from "./Logged.vue?vue&type=script&lang=js&"
export * from "./Logged.vue?vue&type=script&lang=js&"
import style0 from "./Logged.vue?vue&type=style&index=0&id=70378bc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70378bc2",
  null
  
)

export default component.exports